export const iconFontAwesomeFilmVideoVideo = (
	<i className="fa-solid fa-video"></i>
);
